import { useState } from 'react';
import api from '@services/api/api.service';

export const useAdmin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getDashboardStats = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get('/admin/dashboard/stats');
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch dashboard stats');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const getMentorList = async (filters = {}) => {
    setLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams();
      if (filters.status) params.append('status', filters.status);
      if (filters.search) params.append('search', filters.search);
      if (filters.page) params.append('page', filters.page);
      if (filters.limit) params.append('limit', filters.limit);

      const response = await api.get(`/admin/mentors?${params.toString()}`);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch mentor list');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const getMentorDetails = async (mentorId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get(`/admin/mentors/${mentorId}`);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch mentor details');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const approveDocument = async (documentId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.put(`/admin/documents/${documentId}/approve`);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to approve document');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const rejectDocument = async (documentId, rejectionReason) => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.put(`/admin/documents/${documentId}/reject`, {
        rejectionReason
      });
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to reject document');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const approveMentor = async (mentorId, notes = '') => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.put(`/admin/mentors/${mentorId}/approve`, { notes });
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to approve mentor');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const rejectMentor = async (mentorId, reason) => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.put(`/admin/mentors/${mentorId}/reject`, { reason });
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to reject mentor');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const deleteMentor = async (mentorId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.delete(`/admin/mentors/${mentorId}`);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to delete mentor');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    getDashboardStats,
    getMentorList,
    getMentorDetails,
    approveDocument,
    rejectDocument,
    approveMentor,
    rejectMentor,
    deleteMentor
  };
};
